import React from 'react';

import type { RootMenuItem } from '../../types';

import { SsrModule } from 'app/constants/ssrModules';

import { Item } from './Item';

import style from './RootMenu.module.scss';

type RootMenuItemsProps = {
  list: RootMenuItem[];
  ssrDataId?: SsrModule;
};

export const RootMenu: React.FC<RootMenuItemsProps> = ({
  list,
  ssrDataId,
}) => {
  return (
    <ul data-ssr-id={ssrDataId}
        data-test="left-menu"
        className={style.list}>
      {list.map((entry) => (
        <Item key={entry.key}
              entry={entry} />
      ))}
    </ul>
  );
};
